import React, { Component } from 'react';
import HeatMap from 'react-heatmap-grid';
const { AbortController } = window;



//const xLabels = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
//const yLabels = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];
//const data = new Array(yLabels.length).fill(0).map(() =>
//    new Array(xLabels.length).fill(0).map(() => Math.floor(Math.random() * 100))
//);
class Heatmap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: this.props.startDate,
            endDate: this.props.endDate,
            barChartIconInactive: false,
            matrixData: [],
            options: {
                maintainAspectRatio: false,
            },
            IsDataLoaded: false,
            XlabelString: [],// ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            YlabelString: [],// ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
            ColorCode: this.props.data.ColorCode,
            IFrameId: this.props._Index,
            noDataDisplay: '',
            userdata: JSON.parse(localStorage.getItem('user'))
        };
        this.handlechangea = this.handlechangea.bind(this);
        this.abortController = null;
        this.debounceTimer = null;
    }
    handlechangea(e) {
        this.props.handlechangea(e);
    }
    componentDidUpdate(prevProp) {
        if (prevProp.data.RequestJson != this.props.data.RequestJson && this.props.data.type == "Heatmap" && this.props.data.id == 'heatmap11' && (this.props.data.url.indexOf('api/publicAPI')) > 0) {
            this.fetchData_locally();
        }
    }
    componentDidMount() {
        if (this.props.data.type == "Heatmap" && this.props.data.id == 'heatmap11' && (this.props.data.url.indexOf('api/publicAPI')) > 0) {
            this.fetchData_locally();
            window.Chart.defaults.global.defaultFontFamily = `'Fira Sans', sans-serif`;
        }
    }
    componentWillUnmount() {
        if (this.abortController) {
            this.abortController.abort();
        }
    }

    fetchData_locally() {

        // Cancel any previous pending request
        if (this.abortController) {
            this.abortController.abort();
        }
        // Create a new AbortController for this request
        this.abortController = new AbortController();

        try {
            const xLabels = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
            const yLabels = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];
            const data = new Array(yLabels.length).fill(0).map(() =>
                new Array(xLabels.length).fill(0).map(() => Math.floor(Math.random() * 100))
            );
            //this.setState({
            //    matrixData: data,
            //    noDataDisplay: 'Loading. Please wait.'
            //});
        }
        catch (err) {
        }
        //this.setState({
        //    IsDataLoaded: false,
        //    noDataDisplay: 'Loading. Please wait.'
        //});
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'requestHeader': this.props.data.RequestJson1 },
            body: this.props.data.RequestJson
        };
        return fetch(this.props.data.url, requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                try {
                    this.setState({
                        matrixData: JSON.parse(apidata.dataset),
                        XlabelString: apidata.xLabels,
                        YlabelString: apidata.yLabels,
                        noDataDisplay: ''
                    });
                }
                catch (error) {

                }
            })
            .catch(err => {
                if (err.name === "AbortError") {
                    // Expected cancel, just ignore
                    //console.log("Fetch request aborted");
                    return;
                }
                // Unexpected error
                //console.error("Fetch error:", err);
                this.setState({
                    IsDataLoaded: true,
                    noDataDisplay: 'Error while loading data'
                });
            });
    }
    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            }
            catch (error) {
                const data = [];
                return data;
            }
        });
    }
    render() {
        return (
            <div className="bar oList">
                <div className="widget-head mobile-position">
                    <h3>
                        <a><span data-title={this.props.data.title} className="transition-title">{this.props.data.title}<p>{this.props.data.Subtitle}</p></span></a>
                    </h3>
                </div>
                <div className="widget-iframe heatmap-iframe">
                    <div className="myListChart myColumnChart col-lg-12" id={this.props.data.id}>
                        <div>{
                            this.state.matrixData != null && this.state.matrixData.length > 0 ?
                                <HeatMap
                                    xLabels={this.state.XlabelString}
                                    yLabels={this.state.YlabelString}
                                    data={this.state.matrixData}
                                    height={20}
                                    cellStyle={(background, value, min, max, data, x, y) => {
                                        const intensity = (value - min) / (max - min);
                                        return {
                                            background: `rgba(42, 82, 75, ${intensity + 0.1})`, // Background color with intensity
                                            color: "#ff8b6c", // Text color set to red
                                            textAlign: "center", // Center align text horizontally
                                            verticalAlign: "middle", // Center align text vertically
                                            fontSize: "10px", // Set font size for text
                                            lineHeight: "1",
                                            fontWeight:"normal"// Ensure line-height matches cell height
                                        };
                                    }}
                                    cellRender={value => value && `${value}`} // Ensure the value is rendered
                                /> : null
                        }
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
export default Heatmap;